export const buildNum = '12803';
export const buildEnvironment = 'production';
